import { AxiosError } from 'axios';

interface ProblemDetail { title?: string; detail?: string; message?: string }

export function extractError(err: unknown, fallback = 'Something went wrong'): string {
  if (err instanceof AxiosError) {
    const data = err.response?.data as ProblemDetail | undefined;
    return data?.detail ?? data?.message ?? data?.title ?? err.message ?? fallback;
  }
  if (err instanceof Error) return err.message;
  return fallback;
}
